import {Component, Input, OnInit} from '@angular/core';
import {StudentRequestComponent} from "../modals/student-request/student-request.component";
import {ModalController} from "@ionic/angular";
import {AuthService} from "../../../services/mygreencountry/auth.service";

@Component({
    selector: 'app-no-course-notice',
    templateUrl: './no-course-notice.component.html',
    styleUrls: ['./no-course-notice.component.scss'],
})
export class NoCourseNoticeComponent implements OnInit {

    @Input() futureGroup: boolean = false;
    @Input() pastGroup: boolean = false;
    @Input() currentGroup: boolean = false;
    @Input() class: string = '';

    public isParent: boolean = false;
    public isParentRole: boolean = false;

    constructor(private modalCtrl: ModalController, private authService: AuthService) {
    }

    ngOnInit() {
        this.isParent = this.authService.isParent();
        this.isParentRole = this.authService.isParentRole();
    }


    async openRequestModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();
    }

}
